import { useEffect, useRef } from "react";
import { main } from "../projects/car_neural/main";


const canvasStyle: React.CSSProperties = {
    borderRadius: "10px",
    backgroundColor: "black"
}

const wrapperStyle: React.CSSProperties = {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#363434",
    width: "40vw",
    borderRadius: "10px",
    margin: "0 auto",
}

const CarNeuralPage = () => {

    const carCanvas = useRef<HTMLCanvasElement>(null);
    const networkCanvas = useRef<HTMLCanvasElement>(null);
    let controls: { save: () => void; discard: () => void; };
    useEffect(() => {

        if (carCanvas.current && networkCanvas.current) {
            controls = main(carCanvas.current, networkCanvas.current);
        }


    }, []);



    return (
        <div className="page-content center">
            <h1 hidden>Car Neural Network</h1>
            <p style={{ textAlign: "center", width: "50vw", marginBottom: "2rem" }}>A simulation of a car that learns to drive using a neural network. The car is controlled by a neural network that is trained using a genetic algorithm. The car is able to learn to drive around a track without crashing.</p>
            <div style={wrapperStyle}>
                <canvas style={canvasStyle} ref={carCanvas} id="canvas"></canvas>
                <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                    <button style={{ background: 'white' }} onClick={() => controls.save()}>Save</button>
                    <button style={{ background: 'white' }} onClick={() => controls.discard()}>Discard</button>
                </div>
                <canvas style={canvasStyle} ref={networkCanvas} id="networkCanvas"></canvas>
            </div>

        </div>
    );

}

export default CarNeuralPage;